import { withTranslation } from 'react-i18next';
import { Box, Backdrop, Modal, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import { IConfirmModalView } from './interfaces';

import { useStyles } from './styles';
import BasicButton from '@components/BasicButton';
import { CloseIcon } from '@icons';

const ConfirmModalView = ({
  icon,
  title,
  message,
  open,
  onClose,
  onCancel,
  onConfirm,
  confirmButtonName,
  cancelButtonName,
  t: translate,
  sx,
  isConfirmLoading = false,
  isCancelLoading = false,
}: IConfirmModalView) => {
  const classes = useStyles();

  return (
    <Modal
      sx={{ ...classes.root, ...sx?.root }}
      open={open}
      components={{ Backdrop }}
    >
      <Box component="div" sx={classes.container}>
        {onClose ? <CloseIcon sx={classes.close} onClick={onClose} /> : null}
        <Box component="div" sx={classes.iconContainer}>
          {icon || <LogoutIcon />}
        </Box>
        {title && <Typography sx={classes.title}>{title}</Typography>}
        <Typography sx={classes.description}>{message}</Typography>
        <Box component="div" sx={classes.buttonContainer}>
          {onCancel ? (
            <BasicButton
              onClick={onCancel}
              loading={isCancelLoading}
              disabled={isConfirmLoading}
              sx={classes.button}
            >
              {cancelButtonName || translate('userProfile.cancel')}
            </BasicButton>
          ) : null}
          {onConfirm ? (
            <BasicButton
              primary
              onClick={onConfirm}
              loading={isConfirmLoading}
              disabled={isCancelLoading}
              sx={classes.button}
            >
              {confirmButtonName || 'OK'}
            </BasicButton>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default withTranslation()(ConfirmModalView);
